var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNordicEmailActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.821,
    height: 32.68,
    viewBox: "0 0 32.821 32.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(-761 -814.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(759 814.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(3 1.005)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    y1: 10.145,
    x2: 9.434,
    transform: "translate(0.415 19.978)",
    fill: "#fff",
    stroke: "#575651",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x1: 9.434,
    y1: 10.145,
    transform: "translate(20.971 19.978)",
    fill: "#fff",
    stroke: "#575651",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M31.821,57.43,16.411,69.391l-4.857-3.771L1,57.43",
    transform: "translate(-1 -45.096)",
    fill: "none",
    stroke: "#575651",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M27.978,41.78,31.557,44.6a.7.7,0,0,1,.264.544v16.1A2.258,2.258,0,0,1,29.565,63.5H3.256A2.258,2.258,0,0,1,1,61.239V45.3a.7.7,0,0,1,.26-.542l3.323-2.649",
    transform: "translate(-1 -32.867)",
    fill: "none",
    stroke: "#575651",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M34.86,7.2l7.581-6.046a.691.691,0,0,1,.859,0l7.6,5.983",
    transform: "translate(-27.459 -1.005)",
    fill: "none",
    stroke: "#575651",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M34.86,29.35H53.908a.566.566,0,0,1,.568.566v8.457",
    transform: "translate(-27.459 -23.154)",
    fill: "none",
    stroke: "#575651",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M18,38.373V30.039a.689.689,0,0,1,.689-.689h2.995",
    transform: "translate(-14.284 -23.154)",
    fill: "none",
    stroke: "#575651",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "*",
    transform: "translate(19.062 14.913)",
    fill: "#7d6630",
    fontSize: 6,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "*")))), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 7,
    transform: "translate(771.5 827.5)",
    fill: "none",
    stroke: "#7d6630",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M0,0H10",
    transform: "translate(772.5 831.967)",
    fill: "none",
    stroke: "#7d6630",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNordicEmailActive);
export default __webpack_public_path__ + "static/media/nordic_email_active.abe3d26e06b7bbfba8504da619fa806f.svg";
export { ForwardRef as ReactComponent };